// Till layout codes from tillAccess.userAccessController.layout.
// 1 Retail · 3 Kiosk · 4 SuperMarket · 5 Fashion · anything else Restaurant.
export const LAYOUT = Object.freeze({ RETAIL: 1, KIOSK: 3, SUPERMARKET: 4, FASHION: 5 });

export function getTillLayout(tillData) {
  const raw = tillData?.tillAccess?.userAccessController;
  if (!raw) return LAYOUT.RETAIL;
  try {
    const access = typeof raw === "string" ? JSON.parse(raw) : raw;
    const layout = parseInt(access?.layout ?? LAYOUT.RETAIL, 10);
    return Number.isNaN(layout) ? LAYOUT.RETAIL : layout;
  } catch {
    return LAYOUT.RETAIL;
  }
}

export const isFashionLayout = (tillData) => getTillLayout(tillData) === LAYOUT.FASHION;

// SuperMarket and Fashion share the online-only (disableOfflineBilling) order
// confirmations and the return-before-exchange wait in useOrderProcessing.
export const usesSuperMarketOrderFlow = (tillLayout) => tillLayout === LAYOUT.SUPERMARKET || tillLayout === LAYOUT.FASHION;
